/* eslint-disable no-unused-vars */
export enum UserType {
  Unknown,
  Student,
  NewGrad,
  Professional,
}
/* eslint-enable no-unused-vars */

export type UserExperince = {
  role: string;
  company: string;
  location: string;
  start_time: string;
  end_time: string;
  description: string;
  id: number;
};

export type UserProject = {
  name: string;
  personal: boolean;
  organization: string;
  start_time: string;
  end_time: string;
  description: string;
  id: number;
};

export type UserEducation = {
  degree: string;
  school: string;
  start_date: string;
  end_date: string;
  minor: string;
  gpa: string;
  notes: string;
  id: number;
};

export type BulletScore = {
  text: string;
  skills: boolean;
  numbers: boolean;
  wording: boolean;
  verbage: boolean;
};

export type UserScore = {
  bullets: BulletScore[];
  total_skills: number;
  total_numbers: number;
  total_wording: number;
  total_verbage: number;
  total: number;
  num_questions: number;
};

export type User = {
  user_type: UserType;
  industry_index: number;
  field_index: number;
  name: string;
  email: string;
  phone: string;
  linkedin: string;
  experiences: UserExperince[];
  projects: UserProject[];
  educations: UserEducation[];
  skills: string[];
  score: UserScore;
  resume_uuid: string;
  preferred_template: string;
};
